// extracted by mini-css-extract-plugin
export default {"ripple":"Button_ripple__tgTKK"};